// Date / week helpers shared by WeeklyPlan and its dialogs
export const DAY_NAMES_FULL = ["Søndag", "Mandag", "Tirsdag", "Onsdag", "Torsdag", "Fredag", "Lørdag"];

export function formatDate(d) { return `${d.getDate()}.${d.getMonth() + 1}`; }
export function dateToKey(d) { return d.toISOString().split("T")[0]; }

export function getDays(s, numWeeks) {
  const days = [];
  const total = numWeeks * 7;
  for (let i = 0; i < total; i++) {
    const d = new Date(s);
    d.setDate(d.getDate() + i);
    days.push(d);
  }
  return days;
}

export function getWeekNumber(d) {
  const date = new Date(d);
  date.setHours(0, 0, 0, 0);
  date.setDate(date.getDate() + 3 - ((date.getDay() + 6) % 7));
  const w1 = new Date(date.getFullYear(), 0, 4);
  return 1 + Math.round(((date.getTime() - w1.getTime()) / 86400000 - 3 + ((w1.getDay() + 6) % 7)) / 7);
}

export function groupIntoWeeks(days) {
  const w = [];
  for (let i = 0; i < days.length; i += 7) w.push(days.slice(i, i + 7));
  return w;
}
